import produce from 'immer'

const immerize = (reducer) => (state, action) =>
  produce(state, (draft) => reducer(draft, action))

export default immerize
